import {
  publicHttpClient,
  type AxiosRequestConfig,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';

export interface GetSameItemPlannerParams {
  name: string;
  overall_dish_tag: string;
  estimated_price: number;
}

export interface SameItemPlannerResponse {
  suggestions: Suggestion[];
}

export interface Suggestion {
  name: string;
  overall_dish_tag: string;
  estimated_price: number;
  category_solo_meal: string[];
  image_thumb_urls: string;
}

export const getSameItemPlannerFn = async (
  params: GetSameItemPlannerParams,
  config: AxiosRequestConfig = {}
): Promise<SameItemPlannerResponse> => {
  const url =
    process.env.NEXT_PUBLIC_APP_FOOD_API_URI +
    apiRoutes.ahafood.web_view.get_same_plan_item;
  const response = await publicHttpClient.get<SameItemPlannerResponse>(url, {
    params,
    ...config,
  });

  return response?.data;
};

export const useGetSameItemPlanner = (
  params: GetSameItemPlannerParams,
  opts?: Omit<
    UseQueryOptions<SameItemPlannerResponse, Error>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<SameItemPlannerResponse, Error>({
    queryKey: [apiRoutes.ahafood.web_view.get_same_plan_item, params],
    queryFn: () => getSameItemPlannerFn(params),
    enabled: Boolean(params.name && params.overall_dish_tag),
    ...opts,
  });
};
